import { useBlocker } from "@tanstack/react-router";
import { FilePlus02, Tag01 } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { LAYOUT_CONSTRAINTS } from "@/utils/layout-constants";
import { TagLibraryEditor } from "./tag-library-editor";
import { useTagLibraryEditor } from "./use-tag-library-editor";

export function CreatorTagsPage() {
  // Always active on the page (no open/close), so it seeds as soon as the tags load.
  const editor = useTagLibraryEditor({ active: true });

  // Warn before navigating away (or closing the tab) with unsaved edits.
  const blocker = useBlocker({
    shouldBlockFn: () => editor.isDirty,
    enableBeforeUnload: () => editor.isDirty,
    withResolver: true,
  });

  return (
    <div className="flex flex-col w-full h-screen gap-8 items-center">
      <div className={`${LAYOUT_CONSTRAINTS.CONTAINER_WIDTH} flex flex-col gap-5 h-full px-16 pt-16 pb-8`}>
        <div className="flex flex-row items-start justify-between flex-shrink-0">
          <div className="flex flex-col gap-1">
            <h1 className="text-xl font-normal text-secondary flex flex-row items-center gap-2 mb-1">
              <Tag01 className="w-5 h-5" strokeWidth={1.8} />
              Tags
            </h1>
            <span className="text-quaternary text-sm">Manage your tag library</span>
          </div>
          <Button
            color="primary"
            iconLeading={FilePlus02}
            isLoading={editor.isPending}
            disabled={!editor.isDirty}
            onClick={editor.handleSave}
          >
            Save
          </Button>
        </div>

        <TagLibraryEditor editor={editor} />
      </div>

      {/* Unsaved-changes guard */}
      <Dialog open={blocker.status === "blocked"} onOpenChange={() => blocker.status === "blocked" && blocker.reset()}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Discard changes?</DialogTitle>
            <DialogDescription>You have unsaved changes. Leaving now will discard them.</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button color="secondary" size="sm" onClick={() => blocker.status === "blocked" && blocker.reset()}>
              Keep editing
            </Button>
            <Button
              color="primary-destructive"
              size="sm"
              onClick={() => blocker.status === "blocked" && blocker.proceed()}
            >
              Discard
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
